module.exports = __webpack_public_path__ + "img/logo1.bb0784a1.jpg";